/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imageGetImageTobase64 } from "../../funcs/imageGetImageTobase64.js";
import { GetImageTobase64Request$zodSchema } from "../../models/getimagetobase64op.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetImageTobase64Request$zodSchema,
};

export const tool$imageGetImageTobase64: ToolDefinition<typeof args> = {
  name: "image-get-image-tobase64",
  description: `图片转 Base64

看到一张网上的图片，想把它转换成 Base64 编码以便嵌入到你的 HTML 或 CSS 中？用这个接口就对了。

## 功能概述
你提供一个公开可访问的图片 URL，我们帮你把它下载下来，并转换成包含 MIME 类型的 Base64 Data URI 字符串返回给你。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imageGetImageTobase64(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
